import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import { MegaMenu } from 'primereact/megamenu';   
import CeoAllRequest from './Ceo-allRequest';
import CeoApprovedRequest from './Ceo-ApprovedRequest';
import CeoRejectedRequest from './Ceo-RejectedRequest';
import CeoTeamRequestApproval from './Ceo-TeamRequestApproval';
  
const CeoHead = () => {
const [currentTab, setCurrentTab] = useState(1);
  const navigate = useNavigate();  


  useEffect(() => {
   
  }, []);
 
  
  const menu1 = [
    {
      label: 'All Request',
      icon: 'pi pi-fw pi-file',
      command: () => setCurrentTab(1),
    },
    {
      label: 'Request Approval',
      icon: 'pi pi-pencil',
      command: () => setCurrentTab(2),

    },
    {
      label: 'Approved Request',
      icon: 'pi pi-check',
      command: () => setCurrentTab(3),

    },
    {
      label: 'Rejected Request',
      icon: 'pi pi-times',
      command: () => setCurrentTab(4),
    },
     
  ];
 
 

 
  return (
    <div className="tabview-demo">
      <div className="card mb-3">
      
        <MegaMenu model={menu1} />
      </div>
      <div className="flex grid">
         

        <div className="grid col-12" >
          {currentTab && currentTab == 1 && (
            <CeoAllRequest />
            
          )}
            {currentTab && currentTab == 2 && (
             <CeoTeamRequestApproval /> 
          )}
          {currentTab && currentTab == 3 && (
              <CeoApprovedRequest />
          )}
          {currentTab && currentTab == 4 && (
               <CeoRejectedRequest />
          )}

           
        </div>
      </div>
    </div >

  )

         }

 
 export default CeoHead;